'use client';

import dynamic from 'next/dynamic';
import { Interview, PanelCampaign } from '@/types/pulsedb';
import { NextIntlClientProvider } from 'next-intl';
import type { InterviewMessages } from '@/i18n/interviewLocale';

const InterviewComponent = dynamic(() => import('./Interview'), {
  ssr: false
});

export default function InterviewWrapper({
  interview,
  interviewVariantId = null,
  queryParams,
  authenticated = false,
  panelCampaign,
  locale,
  messages,
  rewardsEnabled = false,
  isEdisonWorkspace = false
}: {
  interview: Interview;
  /** The variant the respondent opened, stamped on the conversation it creates. */
  interviewVariantId?: number | null;
  queryParams: any;
  authenticated?: boolean;
  panelCampaign?: PanelCampaign;
  locale: string;
  messages: InterviewMessages;
  rewardsEnabled?: boolean;
  isEdisonWorkspace?: boolean;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <InterviewComponent
        interview={interview}
        interviewVariantId={interviewVariantId}
        queryParams={queryParams}
        authenticated={authenticated}
        panelCampaign={panelCampaign}
        rewardsEnabled={rewardsEnabled}
        isEdisonWorkspace={isEdisonWorkspace}
      />
    </NextIntlClientProvider>
  );
}
